<div class="root-skeleton-layout">
  <header class="root-skeleton-layout__header" data-testid="root-skeleton-header">
    <div class="root-skeleton-layout__header-inner container">
      <div class="root-skeleton-layout__brand">
        <p-skeleton shape="circle" size="3rem" />
        <div class="root-skeleton-layout__brand-copy">
          <p-skeleton width="7rem" height="1rem" />
          <p-skeleton width="5rem" height="0.875rem" />
        </div>
      </div>

      <nav class="root-skeleton-layout__nav" aria-hidden="true">
        @for (item of [1, 2, 3, 4]; track item) {
          <p-skeleton width="5.5rem" height="0.875rem" />
        }
      </nav>

      <div class="root-skeleton-layout__actions">
        <p-skeleton width="6rem" height="2.5rem" borderRadius="9999px" />
        <p-skeleton width="8.5rem" height="2.75rem" borderRadius="9999px" />
      </div>
    </div>
  </header>

  <main class="root-skeleton-layout__content">
    <router-outlet />
  </main>

  <footer class="root-skeleton-layout__footer" data-testid="root-skeleton-footer">
    <div class="root-skeleton-layout__footer-inner container">
      <div class="root-skeleton-layout__footer-grid">
        @for (column of [1, 2, 3]; track column) {
          <div class="root-skeleton-layout__footer-column">
            <p-skeleton width="7rem" height="1.125rem" />
            @for (item of [1, 2, 3, 4]; track item) {
              <p-skeleton width="100%" height="0.875rem" />
            }
          </div>
        }
      </div>

      <div class="root-skeleton-layout__footer-bottom">
        <p-skeleton width="10rem" height="1rem" />
        <p-skeleton width="12rem" height="1rem" />
      </div>
    </div>
  </footer>
</div>
